// Layouts write --rewamp-nav-height via applyNavHeight; when none does, the 56px CSS fallback applies.
export const REWAMP_NAV_HEIGHT = 56;

const NAV_HEIGHTS = { full: REWAMP_NAV_HEIGHT, none: 0, pwaHome: 0 };

export const navHeight = (chrome = "full") => NAV_HEIGHTS[chrome] ?? REWAMP_NAV_HEIGHT;

export const applyNavHeight = (chrome, px = navHeight(chrome)) => {
  const root = document.documentElement;
  root.style.setProperty("--rewamp-nav-height", `${px}px`);
  return () => root.style.removeProperty("--rewamp-nav-height");
};

const BOTTOM_BAR_VAR = "--pwa-bottom-bar-height";

export const applyBottomBarHeight = (px) => {
  const root = document.documentElement;
  root.style.setProperty(BOTTOM_BAR_VAR, `${px}px`);
  return () => root.style.removeProperty(BOTTOM_BAR_VAR);
};

export const bottomBarOffset = (gap = 0) => `calc(var(${BOTTOM_BAR_VAR}, 0px) + ${gap}px)`;

const NAV_VAR =`var(--rewamp-nav-height, ${REWAMP_NAV_HEIGHT}px)`;

export const stickyTop = (gap = 24) => `calc(${NAV_VAR} + ${gap}px)`;

export const stickyMaxHeight = (gap = 24) =>
  `calc(100vh - ${NAV_VAR} - ${gap * 2}px)`;
